import React from 'react';
import Loadable from 'Jsx/Shared/Loadable';

import { ExitPopupProps } from './ExitPopup';

const ExitPopupLoadable = (props: ExitPopupProps) => (
  <Loadable
    module={() =>
      import(
        /* webpackChunkName: "exit-popup-loadable" */
        './ExitPopup'
      )
    }
    {...props}
  />
);

export default ExitPopupLoadable;
